var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMenu = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "menu"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  opacity: 0,
  transform: "rotate(180 12 12)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 3,
  y: 11,
  rx: 0.95,
  ry: 0.95
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 3,
  y: 16,
  rx: 0.95,
  ry: 0.95
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 3,
  y: 6,
  rx: 0.95,
  ry: 0.95
})))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu.ba4f78fd.svg";
export { ForwardRef as ReactComponent };